import React from 'react'
import { Trans } from 'react-i18next'
import i18next from 'i18next'
import hash from 'object-hash'
import { Button, Modal, Form } from 'react-bootstrap'
import ResponsiveTable from 'src/components/system_wide/responsive_table'
import SearchButton from 'src/components/system_wide/search_button'
import { error } from 'src/components/system_wide/notification'
import FilterGroup from 'src/components/system_wide/filter_group'
import CheckboxFilter from 'src/components/system_wide/checkbox_filter'
import axios from 'src/lib/axios'
import styles from './styles.module.css'

const { t } = i18next

class ParentModal extends React.Component {
  static defaultProps = {
    id: null,

    readonly: false,
    onSave: () => {},
  }

  state = {
    show: false,
    users: [],
    selected_user: null,
    roles: [],
    competence_areas: [],
    filtered_areas: [],
    filtered_roles: [],
    search_filter: '',
    sortData: { sort_column: '', sort_direction: '' },

    filters_hash: '',
  }

  initialFiltersHash = ''
  tableRef = null

  constructor(props) {
    super(props)
    this.tableRef = React.createRef()
  }

  show = async ({ priority: business_role_priority, parent_user, roles, competence_areas }) => {
    const filtered_roles_priority = Array.from(
      { length: business_role_priority - 2 },
      (_, i) => business_role_priority - 1 - i
    )
    roles = roles.filter(r => filtered_roles_priority.includes(r.priority))
    const filtered_roles = roles.map(r => r.id)
    const filtered_areas = competence_areas.map(a => a.id)
    try {
      let response = await axios({
        url: `/api/users/all`,
        params: {
          filtered_roles_priority,
        },
      })
      this.setState(
        {
          show: true,
          users: response.data.users,
          selected_user: parent_user?.id ?? null,
          filtered_roles,
          filtered_areas,
          competence_areas,
          roles,
        },
        () => {
          let { filtered_roles, filtered_areas } = this.state
          filtered_roles.sort()
          filtered_areas.sort()
          this.initialFiltersHash = hash({
            filtered_roles,
            filtered_areas,
          })

          this.updateFiltersHash()
        }
      )
    } catch (err) {
      error(t('store.users.get_users_error', 'Impossibile recuperare lista utenti'))
      this.setState({ users: [] })
    }
  }

  hide = () => {
    this.setState({
      show: false,
      users: [],
      filtered_areas: [],
      filtered_roles: [],
      competence_areas: [],
      search_filter: '',
      sortData: { sort_column: '', sort_direction: '' },
      filters_hash: '',
    })
    this.initialFiltersHash = ''
  }

  updateFiltersHash = () => {
    let { filtered_roles, filtered_areas } = this.state

    filtered_roles.sort()
    filtered_areas.sort()
    this.setState({ filters_hash: hash({ filtered_roles, filtered_areas }) })
  }

  toggleUser = ({ target: { value } }) => {
    this.setState({ selected_user: parseInt(value) })
  }

  selectUserRadio = ({ rowData }) => {
    let { selected_user } = this.state

    return (
      <Form.Check
        type="radio"
        className="py-1"
        value={rowData.id}
        checked={selected_user === parseInt(rowData.id)}
        onChange={this.toggleUser}
      />
    )
  }
  getColumns = () => [
    {
      title: '',
      className: 'd-lg-block text-center',
      style: { width: '5%', minWidth: '3rem' },
      data: this.selectUserRadio,
    },
    {
      title: t('components.accounts.username', 'Username'),
      className: 'd-lg-block flex-fill',
      style: { width: '23%' },
      sortable: true,
      data: 'username',
    },
    {
      title: t('components.accounts.name', 'Nome'),
      className: 'd-none d-lg-block',
      style: { width: '23%' },
      sortable: true,
      data: 'first_name',
    },
    {
      title: t('components.accounts.surname', 'Cognome'),
      className: 'd-none d-lg-block',
      style: { width: '23%' },
      sortable: true,
      data: 'last_name',
    },
    {
      title: t('components.users.role', 'Ruolo'),
      className: 'd-none d-sm-block',
      style: { width: '23%' },
      sortable: true,
      data: 'role_name',
    },
  ]

  onChangeFilter = name => values => {
    this.setState({ [name]: values }, () => {
      this.updateFiltersHash()
    })
  }

  onChangeSearchFilter = filter => this.setState({ search_filter: filter.replace(/[.*?^$]+/, '') })

  handleConfirm = () => {
    let { users, selected_user } = this.state
    this.props.onSave(users.find(u => u.id === selected_user))
    this.hide()
  }

  filterUsers = () => {
    let { users: all_users, filtered_areas, filtered_roles, search_filter, sortData } = this.state

    let users = all_users

    let regexp = new RegExp(`.*${search_filter ? search_filter : ' '}.*`, 'i')
    users = users.filter(u => {
      let name = `${u.first_name} ${u.last_name}`
      let has_area =
        u.areas_competence_ids.length === 0 || u.areas_competence_ids.some(id => filtered_areas.includes(id))
      let has_roles = !u.role_id || filtered_roles.includes(u.role_id)

      return regexp.test(name) && has_area && has_roles
    })

    let { sort_column, sort_direction } = sortData

    if (sort_column) {
      users = users.sort((a, b) => {
        let valueA = a[sort_column] || ''
        let valueB = b[sort_column] || ''

        if (typeof valueA === 'string') {
          valueA = valueA.toLowerCase()
          valueB = valueB.toLowerCase()
        }

        if (valueA < valueB) {
          return sort_direction === 'ASC' ? -1 : 1
        }
        if (valueA > valueB) {
          return sort_direction === 'ASC' ? 1 : -1
        }
        return 0
      })
    }

    return users
  }

  onRowClick = rowData => {
    let { id, enabled } = rowData
    if (enabled === false) return
    const event = { target: { value: id.toString() } }
    this.toggleUser(event)
  }

  getData = (_index = 0, _chunkSize, sortData) => {
    this.setState({ sortData })
  }

  onResetFilters = () => {
    this.setState(
      {
        filtered_areas: this.state.competence_areas.map(s => s.id),
        filtered_roles: this.state.roles.map(u => u.id),
      },
      () => {
        this.updateFiltersHash()
      }
    )
  }
  render() {
    let { show, users, search_filter, filtered_areas, filtered_roles, filters_hash } = this.state
    users = this.filterUsers()
    return (
      <Modal
        backdrop="static"
        centered
        contentClassName={styles.add_users_modal}
        show={show}
        onHide={this.hide}
        size="xl">
        <Modal.Header>
          <Modal.Title>
            <Trans i18nKey="components.users.parent_modal.title">Seleziona supervisore</Trans>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column" style={{ height: '60vh' }}>
          <div className="toolbar px-2 flex-wrap">
            <FilterGroup
              className="toolbar-item"
              showResetFilters={this.initialFiltersHash !== filters_hash}
              onResetFilters={this.onResetFilters}>
              <CheckboxFilter
                label={t('filter_aree', 'Aree')}
                items={this.state.competence_areas}
                filteredItems={filtered_areas}
                onChangeFilter={this.onChangeFilter('filtered_areas')}
                disabled={this.props.show_form}
              />
              <CheckboxFilter
                label={t('filter_role', 'Ruolo')}
                items={this.state.roles}
                filteredItems={filtered_roles}
                onChangeFilter={this.onChangeFilter('filtered_roles')}
              />
            </FilterGroup>
            <div className="flex-fill"></div>
            <div className="flex-fill">
              <SearchButton
                className="float-end"
                value={this.state.search_filter}
                onChange={this.onChangeSearchFilter}
              />
            </div>
          </div>
          <ResponsiveTable
            ref={this.tableRef}
            className={`flex-fill ${styles.add_users_table}`}
            data={users}
            getData={this.getData}
            totalRecords={users.length}
            columns={this.getColumns()}
            filter={search_filter}
            hideStatusBar={false}
            onRowClick={this.props.readonly === false && this.onRowClick}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.hide} variant="secondary">
            <Trans i18nKey="buttons.cancel">Annulla</Trans>
          </Button>
          <Button onClick={this.handleConfirm} variant="primary">
            <Trans i18nKey="buttons.confirm">Conferma</Trans>
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ParentModal
